module.exports = __webpack_public_path__ + "graphics/player-play.ckh.22e25f7e3fc9a1829bf27a57ed882417.svg";